import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let outgoing = req;
    const hasAuth = req.headers.has('Authorization');
    const token = this.auth.getToken();

    if (!hasAuth && token) {
      const effectiveRoleId = this.getEffectiveRoleId();
      outgoing = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          ...(effectiveRoleId ? { 'X-OM-Effective-Role-Id': String(effectiveRoleId) } : {}),
        },
      });
    }

    return next.handle(outgoing).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.auth.clearSession();
          const currentUrl = this.router.url;
          if (!currentUrl.startsWith('/login') && !currentUrl.startsWith('/sso')) {
            this.router.navigate(['/login'], { queryParams: { reason: 'session-expired' } });
          }
        }
        return throwError(() => err);
      })
    );
  }

  private getEffectiveRoleId(): number {
    try {
      const user = JSON.parse(localStorage.getItem('UserInfo') || '{}');
      return Number(user.effectiveRoleId || user.role_id || 0);
    } catch {
      return 0;
    }
  }
}
